import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { useGetAgroGroupsQuery } from 'services/api/Meteorology/Agro';

export default function useLocationGroups() {
  const { data, error } = useGetAgroGroupsQuery();

  useHandleRequestErrors(error as ResponseError);

  return { groups: data };
}
